import { render } from "./BrandingEditor.vue?vue&type=template&id=52fa474f&scoped=true"
import script from "./BrandingEditor.vue?vue&type=script&lang=js"
export * from "./BrandingEditor.vue?vue&type=script&lang=js"

import "./BrandingEditor.vue?vue&type=style&index=0&id=52fa474f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52fa474f"]])

export default __exports__